/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebChangeEmailSubscriptionFrequencyRequest,
  TWebChangeEmailSubscriptionFrequencyModel,
  IMappers,
  TWebChangeEmailSubscriptionFrequencyResponse,
  TWebChangeEmailSubscriptionFrequencyResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebChangeEmailSubscriptionFrequencyModel(
  parameters: TWebChangeEmailSubscriptionFrequencyRequest,
): TWebChangeEmailSubscriptionFrequencyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'saved-searches',
    pathApi: '/v1/web/change-email-subscription-frequency/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebChangeEmailSubscriptionFrequencyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebChangeEmailSubscriptionFrequencyRequest;
}

export async function fetchWebChangeEmailSubscriptionFrequency<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebChangeEmailSubscriptionFrequencyOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebChangeEmailSubscriptionFrequencyResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebChangeEmailSubscriptionFrequencyModel(parameters),
    config,
  )) as FetchResponse<TWebChangeEmailSubscriptionFrequencyResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TWebChangeEmailSubscriptionFrequencyResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebChangeEmailSubscriptionFrequencyResponse>;
}
